<template>

    <div>
        <money
            v-show="edit === true"
            style="width:100%;text-align:right;"
            ref="moneyElement"
            v-model="value"
            v-bind="money"
            @keydown.enter.native="onEnter"
            @keydown.esc.native="onEscape"
        ></money>
        <span v-show="edit !== true" @dblclick="onDblClick" :class="{ italic: changed }">{{ curValue | toCurrency(false) }}</span>
    </div>

</template>

<script>

    import {Money} from 'v-money';

    export default {

        components: {
            Money,
        },

        data() {
            return {
                edit:false,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '€ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                value:0,
                changed: false,
            }
        },

        methods: {
            onDblClick() {
                this.edit = true;
                this.value = this.curValue / 100;
                this.$refs.moneyElement.$el.focus()
            },
            onEnter() {
                this.edit = false;
                this.storeValue(this.value * 100);
            },
            onEscape() {
                this.edit = false;
            },
            storeValue(value){
                if (value !== this.value || value === 0) {
                    this.changed = true;
                    this.$emit("updateValue", value);
                }
            },
        },

        name:"BusinessLiquidityMoneyCell",

        props: {
            curValue: { required:true },
        },

    }

</script>
